module.exports = __webpack_public_path__ + "static/timeline1998-9cb5ac34ad837d57e3eed5e28720290b.jpeg";